import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from './it.json'
import en from './en.json'
import { USE_TRANSLATIONS } from '../config'
import { getAppTranslations } from 'services/translations'

export const determineInitialLanguage = () => {
  const browserLang = navigator.language || navigator.languages[0]

  const langPrefix = browserLang.split('-')[0].toLowerCase()

  if (['it', 'en', 'es', 'de', 'zh'].includes(langPrefix)) {
    return langPrefix
  }

  return 'en'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      it: {
        translation: it,
      },
      es: {
        translation: {},
      },
      de: {
        translation: {},
      },
      zh: {
        translation: {},
      },
    },
    lng: determineInitialLanguage(),
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
      caches: [],
    },
  })
  .then(() => console.debug('Translations init'))
  .catch(() => console.debug('Translations init error'))

export const loadDynamicTranslations = async () => {
  if (USE_TRANSLATIONS) {
    try {
      const currentLang = i18n.language

      const translations = await getAppTranslations(currentLang as 'it' | 'en' | 'es' | 'de' | 'zh')
      i18n.addResourceBundle(currentLang, 'translation', translations, true, true)

      await i18n.changeLanguage(currentLang)

      console.debug(`Dynamic translations loaded successfully for language: ${currentLang}`)
    } catch (e) {
      console.error('Error loading dynamic translations:', e)
    }
  }
}

export const t = i18n.t.bind(i18n)

export default i18n
